class CareerPath {
  constructor(el) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    if (window.innerWidth < 767) {
      $(".js-zoom-modal-trigger").on("click", function () {
        const target = $(this).data("zoom-modal");
        $(`.js-zoom-modal[data-zoom-modal="${target}"]`).addClass("is-active");
        scrollBan();
      });

      $(".js-zoom-modal-close").on("click", function () {
        $(this).closest(".js-zoom-modal").removeClass("is-active");
        scrollBan();
      });
    }

    $(".js-tab-trigger > div").on("click", function () {
      $(this).toggleClass("is-active");
      $(this).siblings().removeClass("is-active");

      $('.js-tab-inner > div').css("display", "none");
      $('.js-tab-inner > div').eq($(this).index()).fadeIn();
    });
  }
}